import PropTypes from 'prop-types'
import OspreyApiService from '../../services/osprey-api'
import { resetContent } from '../content'

export default class BaseAction {

    static get propTypesShape() {
        return PropTypes.shape({
            content: PropTypes.object.isRequired,
            response: PropTypes.object,
            isFetching: PropTypes.bool.isRequired,
            lastUpdated: PropTypes.date,
            success: PropTypes.bool.isRequired
        })
    }

    constructor(resource, verb, path, id, dataKey, service) {
        this.id = id
        this.resource = resource
        this.verb = verb
        this.path = path
        this.service = service || OspreyApiService
        this.dataKey = dataKey
        this.noCache = false
        this.params = undefined
    }

    getDefaultKey() {
        const keyParts = [ this.resource, this.path, this.id ]
        if (this.dataKey) {
            keyParts.push(this.dataKey)
        }
        return keyParts.join('.')
    }

    getKey() {
        return this.getDefaultKey()
    }

    getState(contentByKey) {

        const key = this.getKey()

        const state = {
            isFetching: null,
            lastUpdated: null,
            content: null,
            response: null,
            success: null,
            error: null,
            get hasContent() {
                return !this.isFetching && this.success && this.content
            },
            get hasError() {
                return !this.isFetching && !this.success && this.error
            }
        }

        const defaultState = {
            isFetching: false,
            content: {},
            success: false
        }

        return Object.assign(state, contentByKey[key] || defaultState)

    }

    reset() {
        return resetContent(this)
    }

}



// WEBPACK FOOTER //
// src/actions/base-action/index.js